import { Loader } from 'lucide-react';

import { AgreementPreview } from 'src/containers/SoftwareEscrow/Agreement/ui';
import { useSoftwareEscrow } from 'src/context/software-escrow';
import { EscrowStatusEnum } from 'src/graphql/schema';
import { EmptyBlock } from 'src/components/ui/empty-block';

const BlockWrapper = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="container mx-auto h-full flex flex-col space-y-6">
      <div className="text-base font-semibold text-gray-700">Agreement</div>
      {children}
    </div>
  );
};

const SoftwareEscrowAgreement = () => {
  const {
    softwareEscrow: { status },
  } = useSoftwareEscrow();

  if (status === EscrowStatusEnum.AdminReview)
    return (
      <BlockWrapper>
        <EmptyBlock
          title="Agreement in progress"
          description="We’ll let you know as soon as the agreement is ready for review."
          icon={Loader}
          classes={{
            title: 'text-base',
            card: 'grow-1 [&>div]:h-full',
            content: 'h-full flex flex-col justify-center',
          }}
        />
      </BlockWrapper>
    );

  return (
    <BlockWrapper>
      <AgreementPreview />
    </BlockWrapper>
  );
};

export default SoftwareEscrowAgreement;
